import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type {
    IPwlLabQuestCompleteFormValues,
    IPwlLabQuestCompleteModel,
    IPwlLabQuestCompleteSubmitResult,
} from '@/types/history/pwl-lab-quest-complete';

const PWL_LAB_QUEST_COMPLETE_ENDPOINT = '/api/register/pwl-lab-quest-complete';

const defaultPwlLabQuestCompleteModel: IPwlLabQuestCompleteModel = {
    id: 0,
    editKey: '',
    questCompletedDate: '',
    questCompletedWhere: '',
    showMentorOffer: false,
    languageData: {},
};

export const usePwlLabQuestComplete = (registrationId: number, editKey: string) => {
    const url = `${PWL_LAB_QUEST_COMPLETE_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultPwlLabQuestCompleteModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IPwlLabQuestCompleteFormValues, unknown, IPwlLabQuestCompleteSubmitResult>(
        url,
        (values) => values,
        () => ({}),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
